import React, { useEffect, useState } from 'react'
import { Button, Icon, Tooltip } from 'antd'
import { CheckUserRight } from '../../dashboard/views/DashboardUserWise'
import UserActivities from '../drawer/userActivities'

const WebActivityComponents = (props) => {
  let [visible, setVisible] = useState(false)
  let { userData, currentUser } = props

  return (
    <CheckUserRight user={currentUser} rightUserType={['admin']}>
      <Tooltip title='Web Activity'>
        <button
          className={'btn'}
          onClick={() => {
            setVisible(true)
          }}
        >
          <Icon type={'history'} />
        </button>
      </Tooltip>
      {visible ?
        <UserActivities
          visible={visible}
          user={userData}
          onClose={() => setVisible(false)} />
        : null}
    </CheckUserRight>
  )
}
export default WebActivityComponents
